import { Order, Paginator, Parcel } from '@/types'
import { requests, responseBody } from '../http/axios'
import { removeNullParams } from '@/helper/formatter'

type ListOrderParams = {
  page?: number
  limit?: number
  from?: string
  until?: string
  userId?: string
}

export class OrderService {
  static async getOrders(params: ListOrderParams): Promise<Paginator<Order>> {
    return await requests.get('orders?' + removeNullParams(params).toString())
  }

  static async getOrder(uid: string): Promise<Order> {
    return await requests.get(`orders/${uid}`).then(responseBody)
  }

  static async getOrderLabels(uid: string): Promise<Order> {
    return await requests.get(`orders/${uid}/labels`)
  }

  static async createOrder(orderData: {
    provider_id: string | number
    sender_address_id: string | number
    recipient_address_id: string | number
    dropoff_point_id: string | number
    parcels: Partial<Parcel>[]
  }): Promise<Order> {
    return await requests.post('orders', orderData).then(responseBody)
  }

  static async cancelOrder(uid: string): Promise<void> {
    return await requests.delete(`orders/${uid}`)
  }
}
